module.exports = __webpack_public_path__ + "vue/img/eurasiantech.a9eda2fa.png";